import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Holds the tab-category chosen on the entry step (after a final product is
 * picked). When set, the configurator shows only that category within its tab
 * and hides its sibling categories. Null means "no entry filtering" (the
 * product had no entry categories configured, i.e. legacy behavior).
 */
@Injectable({ providedIn: 'root' })
export class EntrySelectionService {
  private _entryCategoryId = new BehaviorSubject<number | null>(null);

  get entryCategoryId$(): Observable<number | null> {
    return this._entryCategoryId.asObservable();
  }

  get entryCategoryId(): number | null {
    return this._entryCategoryId.value;
  }

  setEntryCategory(id: number | null): void {
    this._entryCategoryId.next(id);
  }

  clear(): void {
    this._entryCategoryId.next(null);
  }
}
